import React from "react";
import StructuredData from "./src/components/global/structured-data";

// Shared wrapPageElement so gatsby-ssr.js and gatsby-browser.js stay identical
// (Gatsby requires them to match to avoid hydration mismatches). This injects the
// site-wide Organization + WebSite JSON-LD (via react-helmet) into every page's
// <head> without altering anything a user sees.
export const wrapPageElement = ({ element }) => (
  <React.Fragment>
    <StructuredData />
    {element}
  </React.Fragment>
);
